import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';

/**
 * Native system-bar layout for Capacitor Android/iOS.
 * Matches delivery: WebView does not overlay status/nav bars, so 3-button Android
 * navigation stays opaque and content is not visible through the button area.
 */
@Injectable({ providedIn: 'root' })
export class StatusBarService {
  /** Marks Android native WebView so app CSS can scope APK-only safe-area rules. */
  static applyAndroidSafeAreaFix(): void {
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
      document.documentElement.classList.add('android-statusbar-inset');
    }
  }

  async configure(opts?: { isDark?: boolean }): Promise<void> {
    StatusBarService.applyAndroidSafeAreaFix();
    await this.applyNativeBars(opts?.isDark ?? false);
  }

  async updateForTheme(isDark: boolean): Promise<void> {
    StatusBarService.applyAndroidSafeAreaFix();
    await this.applyNativeBars(isDark);
  }

  private async applyNativeBars(isDark: boolean): Promise<void> {
    if (!Capacitor.isNativePlatform()) {
      return;
    }
    try {
      // Keep content above status + navigation bars (delivery behavior).
      await StatusBar.setOverlaysWebView({ overlay: false });
      // Style.Dark = light icons (dark bg); Style.Light = dark icons (light bg).
      await StatusBar.setBackgroundColor({ color: isDark ? '#111827' : '#F9FAFB' });
      await StatusBar.setStyle({ style: isDark ? Style.Dark : Style.Light });
    } catch {
      // Plugin unavailable in web/SSR/tests
    }
  }
}
